/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Phone
 */
export interface Phone {
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  companyId?: number;
  /**
   * Consent. e.g. 'implied', 'consent', 'written_consent', 'revoked'
   * @type {string}
   * @memberof Phone
   */
  consent?: PhoneConsentEnum;
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  dateDncExpires?: number;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  dateDncExpiresIso?: string;
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  dateDncOptOut?: number;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  dateDncOptOutIso?: string;
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  dateDntExpires?: number;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  dateDntExpiresIso?: string;
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  dateDntOptOut?: number;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  dateDntOptOutIso?: string;
  /**
   *
   * @type {number}
   * @memberof Phone
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  dateModifiedIso?: string;
  /**
   * Do-not-call boolean, permanent or temporary
   * @type {boolean}
   * @memberof Phone
   */
  dnc?: boolean;
  /**
   * DNC scope. e.g. 'powerdialer', 'ever', default is 'powerdialer'
   * @type {string}
   * @memberof Phone
   */
  dncScope?: PhoneDncScopeEnum;
  /**
   * Do-not-text boolean, permanent or temporary
   * @type {boolean}
   * @memberof Phone
   */
  dnt?: boolean;
  /**
   * DNT scope. e.g. 'powerdialer', 'ever', default is 'powerdialer'
   * @type {string}
   * @memberof Phone
   */
  dntScope?: PhoneDntScopeEnum;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  e164?: string;
  /**
   * Formatted local phone number. e.g. '(650) 123-4567'
   * @type {string | null}
   * @memberof Phone
   */
  formattedPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Phone
   */
  key: string;
  /**
   * Phone label. e.g. 'mobile', 'work', 'home', 'other'
   * @type {string}
   * @memberof Phone
   */
  label?: PhoneLabelEnum;
  /**
   * User id of the last user to update the phone
   * @type {string | null}
   * @memberof Phone
   */
  lastAuthorId?: string | null;
  /**
   * ID of the last CSV from which this phone was imported from, if last source is 'csv'
   * @type {string | null}
   * @memberof Phone
   */
  lastCsvId?: string | null;
  /**
   * Last update source. e.g. 'api', 'csv'
   * @type {string}
   * @memberof Phone
   */
  lastSource?: PhoneLastSourceEnum;
  /**
   * Arbitrary tags we want to categorize the phone by
   * @type {Array<any>}
   * @memberof Phone
   */
  tags?: Array<any>;
  /**
   * Computed timezone string based on phone number. e.g. 'US/Pacific', 'UTC', etc
   * @type {string | null}
   * @memberof Phone
   */
  timezone?: string | null;
  /**
   * Number validity. e.g. 'good', 'unverified', 'fax', spam'
   * @type {string}
   * @memberof Phone
   */
  validity?: PhoneValidityEnum;
}

/**
 * @export
 */
export const PhoneConsentEnum = {
  Implied: 'implied',
  Consent: 'consent',
  WrittenConsent: 'written_consent',
  Revoked: 'revoked',
} as const;
export type PhoneConsentEnum =
  (typeof PhoneConsentEnum)[keyof typeof PhoneConsentEnum];

/**
 * @export
 */
export const PhoneDncScopeEnum = {
  Powerdialer: 'powerdialer',
  Ever: 'ever',
} as const;
export type PhoneDncScopeEnum =
  (typeof PhoneDncScopeEnum)[keyof typeof PhoneDncScopeEnum];

/**
 * @export
 */
export const PhoneDntScopeEnum = {
  Powerdialer: 'powerdialer',
  Ever: 'ever',
} as const;
export type PhoneDntScopeEnum =
  (typeof PhoneDntScopeEnum)[keyof typeof PhoneDntScopeEnum];

/**
 * @export
 */
export const PhoneLabelEnum = {
  Mobile: 'mobile',
  Work: 'work',
  Home: 'home',
  Other: 'other',
} as const;
export type PhoneLabelEnum =
  (typeof PhoneLabelEnum)[keyof typeof PhoneLabelEnum];

/**
 * @export
 */
export const PhoneLastSourceEnum = {
  Api: 'api',
  Csv: 'csv',
  DpContact: 'dp_contact',
} as const;
export type PhoneLastSourceEnum =
  (typeof PhoneLastSourceEnum)[keyof typeof PhoneLastSourceEnum];

/**
 * @export
 */
export const PhoneValidityEnum = {
  Good: 'good',
  Unverified: 'unverified',
  Disconnected: 'disconnected',
  Fax: 'fax',
  Spam: 'spam',
} as const;
export type PhoneValidityEnum =
  (typeof PhoneValidityEnum)[keyof typeof PhoneValidityEnum];

/**
 * Check if a given object implements the Phone interface.
 */
export function instanceOfPhone(value: object): value is Phone {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function PhoneFromJSON(json: any): Phone {
  return PhoneFromJSONTyped(json, false);
}

export function PhoneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Phone {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    consent: json['consent'] == null ? undefined : json['consent'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateDncExpires:
      json['date_dnc_expires'] == null ? undefined : json['date_dnc_expires'],
    dateDncExpiresIso:
      json['date_dnc_expires_iso'] == null
        ? undefined
        : json['date_dnc_expires_iso'],
    dateDncOptOut:
      json['date_dnc_opt_out'] == null ? undefined : json['date_dnc_opt_out'],
    dateDncOptOutIso:
      json['date_dnc_opt_out_iso'] == null
        ? undefined
        : json['date_dnc_opt_out_iso'],
    dateDntExpires:
      json['date_dnt_expires'] == null ? undefined : json['date_dnt_expires'],
    dateDntExpiresIso:
      json['date_dnt_expires_iso'] == null
        ? undefined
        : json['date_dnt_expires_iso'],
    dateDntOptOut:
      json['date_dnt_opt_out'] == null ? undefined : json['date_dnt_opt_out'],
    dateDntOptOutIso:
      json['date_dnt_opt_out_iso'] == null
        ? undefined
        : json['date_dnt_opt_out_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    dnc: json['dnc'] == null ? undefined : json['dnc'],
    dncScope: json['dnc_scope'] == null ? undefined : json['dnc_scope'],
    dnt: json['dnt'] == null ? undefined : json['dnt'],
    dntScope: json['dnt_scope'] == null ? undefined : json['dnt_scope'],
    e164: json['e164'] == null ? undefined : json['e164'],
    formattedPhone:
      json['formatted_phone'] == null ? undefined : json['formatted_phone'],
    id: json['id'],
    key: json['key'],
    label: json['label'] == null ? undefined : json['label'],
    lastAuthorId:
      json['last_author_id'] == null ? undefined : json['last_author_id'],
    lastCsvId: json['last_csv_id'] == null ? undefined : json['last_csv_id'],
    lastSource: json['last_source'] == null ? undefined : json['last_source'],
    tags: json['tags'] == null ? undefined : json['tags'],
    timezone: json['timezone'] == null ? undefined : json['timezone'],
    validity: json['validity'] == null ? undefined : json['validity'],
  };
}

export function PhoneToJSON(value?: Phone | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    consent: value['consent'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_dnc_expires: value['dateDncExpires'],
    date_dnc_expires_iso: value['dateDncExpiresIso'],
    date_dnc_opt_out: value['dateDncOptOut'],
    date_dnc_opt_out_iso: value['dateDncOptOutIso'],
    date_dnt_expires: value['dateDntExpires'],
    date_dnt_expires_iso: value['dateDntExpiresIso'],
    date_dnt_opt_out: value['dateDntOptOut'],
    date_dnt_opt_out_iso: value['dateDntOptOutIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    dnc: value['dnc'],
    dnc_scope: value['dncScope'],
    dnt: value['dnt'],
    dnt_scope: value['dntScope'],
    e164: value['e164'],
    formatted_phone: value['formattedPhone'],
    id: value['id'],
    key: value['key'],
    label: value['label'],
    last_author_id: value['lastAuthorId'],
    last_csv_id: value['lastCsvId'],
    last_source: value['lastSource'],
    tags: value['tags'],
    timezone: value['timezone'],
    validity: value['validity'],
  };
}
